import { GlAlert, GlLink, GlLoadingIcon, GlSprintf, GlToastMixin } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '../../../../alert.js?vue3';
import { reportToSentry } from '~/ci/utils';
import { __, s__, sprintf } from '~/locale';
import { getQueryHeaders } from '../../../pipeline_details/graph/utils.js?vue3';
import { graphqlEtagPipelinePath } from '~/ci/pipeline_details/utils';
import { setupQueryPollingByVisibility } from '~/graphql_shared/utils';
import getPipelineFailedJobs from '~/ci/pipelines_page/graphql/queries/get_pipeline_failed_jobs.query.graphql';
import { sortJobsByStatus } from './utils';
import FailedJobDetails from './failed_job_details.vue?vue3';
import { POLL_INTERVAL } from './constants';
const JOB_ID_HEADER = __('ID');
const JOB_NAME_HEADER = __('Name');
const STAGE_HEADER = __('Stage');
export default {
    name: 'FailedJobsList',
    components: {
        GlAlert,
        GlLink,
        GlLoadingIcon,
        GlSprintf,
        FailedJobDetails
    },
    mixins: [
        GlToastMixin
    ],
    inject: [
        'graphqlPath'
    ],
    props: {
        isMaximumJobLimitReached: {
            required: true,
            type: Boolean
        },
        pipelineIid: {
            type: String,
            required: true
        },
        pipelinePath: {
            required: true,
            type: String
        },
        projectPath: {
            type: String,
            required: true
        }
    },
    emits: [
        'job-retried'
    ],
    data () {
        return {
            failedJobs: [],
            isLoadingMore: false,
            canTroubleshootJob: false
        };
    },
    apollo: {
        failedJobs: {
            context () {
                return {
                    ...getQueryHeaders(this.graphqlResourceEtag),
                    featureCategory: 'continuous_integration'
                };
            },
            query: getPipelineFailedJobs,
            pollInterval: POLL_INTERVAL,
            variables () {
                return {
                    fullPath: this.projectPath,
                    pipelineIid: this.pipelineIid
                };
            },
            update (data) {
                const jobs = data?.project?.pipeline?.jobs?.nodes || [];
                return sortJobsByStatus(jobs);
            },
            result ({ data }) {
                const pipeline = data?.project?.pipeline;
                this.canTroubleshootJob = pipeline?.troubleshootJobWithAi || false;
            },
            error (e) {
                createAlert({
                    message: e?.message || this.$options.i18n.fetchError,
                    variant: 'danger'
                });
                reportToSentry(this.$options.name, e);
            }
        }
    },
    computed: {
        graphqlResourceEtag () {
            return graphqlEtagPipelinePath(this.graphqlPath, this.pipelineIid);
        },
        isInitialLoading () {
            return this.isLoading && !this.isLoadingMore;
        },
        isLoading () {
            return this.$apollo.queries.failedJobs.loading;
        }
    },
    mounted () {
        this.pollingVisibilityCleanup = setupQueryPollingByVisibility(this.$apollo.queries.failedJobs, POLL_INTERVAL);
    },
    beforeDestroy () {
        this.pollingVisibilityCleanup?.();
    },
    methods: {
        async retryJob (jobName) {
            await this.refetchJobs();
            this.$emit('job-retried');
            this.$toast.show(sprintf(this.$options.i18n.retriedJobsSuccess, {
                jobName
            }));
        },
        async refetchJobs () {
            this.isLoadingMore = true;
            try {
                await this.$apollo.queries.failedJobs.refetch();
            } catch (err) {
                createAlert({
                    message: this.$options.i18n.fetchError
                });
                reportToSentry(this.$options.name, err);
            } finally{
                this.isLoadingMore = false;
            }
        }
    },
    columns: [
        {
            text: JOB_NAME_HEADER,
            class: 'gl-col-4'
        },
        {
            text: STAGE_HEADER,
            class: 'gl-col-2'
        },
        {
            text: JOB_ID_HEADER,
            class: 'gl-col-2'
        }
    ],
    i18n: {
        maximumJobLimitAlert: {
            title: s__('Pipelines|Maximum list size reached'),
            message: s__(`Pipelines| The list can only display 100 jobs. To view all jobs, %{linkStart}go to this pipeline's details page.%{linkEnd}`)
        },
        fetchError: __('There was a problem fetching failed jobs'),
        retriedJobsSuccess: __('%{jobName} job is being retried')
    }
};
